/**
 *
 * Asynchronously loads the component for TermsAndConditions
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import("./index"));
